import { render, staticRenderFns } from "./VolumeMaximization.vue?vue&type=template&id=046feab6"
import script from "./VolumeMaximization.vue?vue&type=script&lang=js"
export * from "./VolumeMaximization.vue?vue&type=script&lang=js"
import style0 from "./VolumeMaximization.vue?vue&type=style&index=0&id=046feab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QCardActions,QBtn,QTable,QInput,QIcon,QTr,QTh,QTd,QCheckbox,QItem,QExpansionItem,QSeparator,QPopupEdit});qInstall(component, 'directives', {ClosePopup});
